import type { Protocol } from '../types'

export function getProtocolKey(protocol?: Protocol) {
  if (!protocol) return 'default'
  return `${protocol.name}${protocol.product ? `-${protocol.product}` : ''}${protocol.version ? `-${protocol.version}` : ''}`
}
